import React from 'react';
import MenuHero from './MenuHero';
import BotanasSection from './BotanasSection';
import CocktailsSection from './CocktailsSection';
import SidesSection from './SidesSection';
import EspecialidadesSection from './EspecialidadesSection';
import TostadasOstionesSection from './TostadasOstionesSection';
import DrinksSection from './DrinksSection';
import DessertSection from './DessertSection';

const Menu: React.FC = () => {
  return (
    <div className="mt-[15vh] md:mt-[0]">
      <MenuHero />
      <BotanasSection />
      <CocktailsSection />
      <SidesSection />
      <EspecialidadesSection />
      <TostadasOstionesSection />
      <DrinksSection />
      <DessertSection />
    </div>
  );
};

export default Menu;
